import { FieldProps, getIn } from 'formik';
import { CreditCardInput } from '@shared/inputs/CreditCardInput';

interface IProps extends FieldProps {
  id?: string;
}

export const CreditCardInputField = ({ form, field, ...props }: IProps) => {
  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  return (
    <CreditCardInput
      {...field}
      {...props}
      id={props.id || field.name}
      error={touched && !!error}
      helperText={(touched && error) || ''}
    />
  );
};
